export const labels = {
	de: {
		headline: 'Stellenangebote',
		text: 'basierend auf Ihrer aktiven Filterung.',
		loadMoreButton: 'Weitere Ergebnisse laden',
		'filter.openMenu': 'Filter',
		'filter.default': 'Alle',
		'filter.jobCategory': 'Tätigkeitsfeld',
		'filter.careerLevel': 'Einstiegslevel',
		'filter.positionLocation': 'Standort',
		'filter.fullTime': 'Vollzeit',
		'filter.partTime': 'Teilzeit',
		'filter.showResults': 'Zeige #{count} Ergebnisse',
		'filter.resetFilters': 'Alle Stellenangebote anzeigen',
	},
	en: {
		headline: 'Open Positions',
		text: 'based on your current filter settings.',
		loadMoreButton: 'More results',
		'filter.openMenu': 'Filter',
		'filter.default': 'All',
		'filter.jobCategory': 'Function',
		'filter.careerLevel': 'Entry Level',
		'filter.positionLocation': 'Location',
		'filter.fullTime': 'Full time',
		'filter.partTime': 'Part time',
		'filter.showResults': 'Show #{count} results',
		'filter.resetFilters': 'View all results',
	},
};
